'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('../../components');

var _NotFound = require('./NotFound.css');

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = (_dec = (0, _reactCssModules2.default)(_NotFound2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound(props) {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call(this, props));
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          'div',
          { styleName: 'notfound' },
          _react2.default.createElement(
            'div',
            { styleName: 'notfound-inner' },
            _react2.default.createElement(_reactHelmet2.default, { title: '404 Not found' }),
            _react2.default.createElement(
              'h1',
              null,
              'Sorry, nothing here.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: '/',
                  title: 'Home' },
                'Click here to return to the home page and get started.'
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return NotFound;
}(_react.Component)) || _class);
exports.default = NotFound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 1312
// module chunks = 0